import { render, staticRenderFns } from "./ReportGenericTable.vue?vue&type=template&id=49e01a94&"
import script from "./ReportGenericTable.vue?vue&type=script&lang=js&"
export * from "./ReportGenericTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports